import { FormItem } from '@xbcb/form-item-components';
import { Input } from 'antd';
import React from 'react';
import { ConditionalOnRemarksCodes } from '../types';
import { VneRequirements } from 'libs/pgaHelpers/epa';

export const ExemptionNumber: ConditionalOnRemarksCodes = ({
  localNamePath,
  disabled,
  importCode,
  required,
}) => {
  const shouldShow = VneRequirements.isExemptionNumberRequired(importCode);

  return shouldShow ? (
    <FormItem
      label={'Exemption Number'}
      name={[...localNamePath, 'vneExemptionNumber']}
      rules={[{ required }]}
    >
      <Input
        aria-label={'Exemption Number Textbox'}
        disabled={disabled}
        maxLength={EXEMPTION_NUMBER_MAX_LENGTH}
      />
    </FormItem>
  ) : null;
};

const EXEMPTION_NUMBER_MAX_LENGTH = 33;
